export default "__VITE_ASSET__Drg2tFnM__"